/**
 * The gesture sheet. Direct manipulation is invisible until someone tells you it is there, so the
 * sheet lists it first and stays one keystroke away.
 */
import w from './Workspace.module.css';
import { useStore } from '../state/store';

const GROUPS: { title: string; rows: [string, string][] }[] = [
  {
    title: 'Moving and resizing',
    rows: [
      ['drag', 'Move the selected room, vessel or source'],
      ['Ctrl + drag', 'Move whatever is under the pointer'],
      ['Alt + drag', 'Pull the wall, edge or corner under the pointer'],
      ['drag a grab point', 'Same, from the squares on the selection'],
      ['drag the ring', 'Turn it, to the nearest degree'],
      ['Shift while dragging', 'Keep to one axis, or turn in 15° steps'],
      ['arrow keys', 'Nudge 100 mm, or 1 m with Shift'],
      ['Page Up / Page Down', 'Nudge up and down'],
    ],
  },
  {
    title: 'Looking',
    rows: [
      ['P / L / V', 'Plan, elevation, 3D'],
      ['F', 'Fit the view to the selection'],
      ['Shift + F', 'Fit the whole site'],
      ['O', 'Origin and axes'],
      ['1 / 2 / 3', 'Zone 0, 1, 2'],
      ['0', 'All zones at once'],
    ],
  },
  {
    title: 'Editing',
    rows: [
      ['S / E', 'Add a source of release, add equipment'],
      ['Ctrl + D', 'Duplicate'],
      ['Delete', 'Delete'],
      ['Ctrl + Z', 'Undo, and Ctrl + Shift + Z to redo'],
      ['Ctrl + K', 'Commands'],
      ['Paste rows', 'A whole register from a spreadsheet'],
    ],
  },
];

export function Shortcuts() {
  const open = useStore((s) => s.helpOpen);
  const setHelp = useStore((s) => s.setHelp);
  if (!open) return null;
  return (
    <div className={w.sheet} role="dialog" aria-label="Keyboard and pointer shortcuts">
      <header>
        <h2>Shortcuts</h2>
        <button type="button" onClick={() => setHelp(false)} aria-label="Close shortcuts">Close</button>
      </header>
      {GROUPS.map((g) => (
        <section key={g.title}>
          <h3>{g.title}</h3>
          <dl>
            {g.rows.map(([keys, what]) => (
              <div key={keys}>
                <dt>{keys}</dt>
                <dd>{what}</dd>
              </div>
            ))}
          </dl>
        </section>
      ))}
    </div>
  );
}
